import React from 'react';
import { modelClass } from '/imports/api/logActivities';
import { ModelFormPage } from '/imports/ui/ModelFormPage';

export const LogActivityPage = () => (
  <ModelFormPage
    modelClass={modelClass as any}
    permission={(user) => !!user?.isSuperUser}
    formSpec={() => [[{ field: 'runId', label: 'Run ID' }], [{ field: 'bot', label: 'Bot' }], [{ field: 'entry', label: 'Entry' }], [{ field: 'level', label: 'Level' }]]}
  />
);
